import { RootState } from './../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  IDivisionLines,
  IDivisionLinesRes,
  ILine,
  ILineResponse,
  IUpdateDivisionLines,
} from '../models/ILine/ILine';
import { API_BASE_URL } from '../helpers/common';

export const linesApi = createApi({
  reducerPath: 'linesApi',
  tagTypes: ['Line'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getLines: build.query<ILineResponse, string>({
      transformResponse: (response: { data: ILineResponse }) => response.data,
      query: (search) => ({
        url: '/lines',
        method: 'GET',
        params: {
          search,
        },
      }),
    }),
    createLine: build.mutation<ILine, ILine>({
      query: (newLine) => ({
        url: '/lines',
        method: 'POST',
        body: newLine,
      }),
    }),
    updateLine: build.mutation<ILine, ILine>({
      query: (updatedLine) => {
        return {
          url: `/api/lines/${updatedLine.id}`,
          method: 'POST',
          body: { name: updatedLine.name },
        };
      },
    }),
    deleteLine: build.mutation<ILine, number>({
      query: (id) => {
        return {
          url: `/api/lines/${id}`,
          method: 'DELETE',
        };
      },
    }),
    deliveryDays: build.query<any, any>({
      transformResponse: (response: { data: any }) => response.data,
      query: () => {
        return {
          url: '/delivery-days',
          method: 'GET',
        };
      },
    }),
    updateDeliveryDays: build.mutation<any, any>({
      transformResponse: (response: { data: any }) => response.data,
      query: () => {
        return {
          url: '/delivery-day/update',
          method: 'POST',
        };
      },
    }),
    divisionLines: build.query<
      IDivisionLines[],
      { search: string; city_id: string; days: number[] | undefined }
    >({
      transformResponse: (response: { data: { data: IDivisionLines[] } }) =>
        response.data.data,
      query: ({ search, city_id, days }) => {
        return {
          url: '/division-lines',
          method: 'GET',
          params: { search, city_id, days: JSON.stringify(days) },
        };
      },
    }),
    editingLines: build.query<
      IDivisionLinesRes,
      {
        search: string;
        area_id: string;
        page: number;
        city_id: string;
        id: string | number;
      }
    >({
      transformResponse: (response: { data: IDivisionLinesRes }) =>
        response.data,
      query: ({ search, area_id, city_id, id, page }) => {
        return {
          url: `/api/division-lines/${id}`,
          method: 'GET',
          params: { search, area_id, city_id, page },
        };
      },
    }),
    updateDivisionLines: build.mutation<
      any,
      { formData: IUpdateDivisionLines; id: string | number }
    >({
      transformResponse: (response: { data: { data: any } }) =>
        response.data.data,
      query: ({ id, formData }) => {
        return {
          url: `/api/division-lines/${id}`,
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});
